export default __webpack_public_path__ + "static/media/bone-disorder.087d317b.jpg";